import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
export const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(", ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CATEGORIES = [
  { slug: "heat-pumps", name: "Heat Pumps", overline: "Hot water heat pumps" },
  { slug: "air-conditioners", name: "Air Conditioners", overline: "Heating & cooling" },
  { slug: "solar-panels", name: "Solar Panels", overline: "Solar PV systems" },
  { slug: "batteries", name: "Batteries", overline: "Battery storage" },
];

export const CATEGORY_BY_SLUG = Object.fromEntries(
  CATEGORIES.map((c) => [c.slug, c]),
);

export function categoryName(slug) {
  return CATEGORY_BY_SLUG[slug]?.name || slug;
}
